import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLocalStorage, getWithToken, patchWithToken, postWithToken } from '../API/Api';
import { toast } from 'react-toastify';
import IntegrationModal from '../components/IntegrationModal';
import { IoMdArrowForward } from 'react-icons/io';
import INTEGRATIONHUB_ICON from '../assets/icons/ComniqaiIcon-V3.0/integrationhub-icon.svg';
import CHECKCIRCLE_ICON from '../assets/icons/ComniqaiIcon-V3.0/check-circlewhiteicon.svg';
import GOHIGHLEVEL_ICON from '../assets/icons/ComniqaiIcon/GoHighLevel-icon.svg';
import HUBSPOT_ICON from '../assets/icons/ComniqaiIcon/Hubspot-icon.svg';
import CALENDLY_ICON from '../assets/icons/ComniqaiIcon/Calendly-icon.svg';
import Loader from '../components/Loader';
import { FiCalendar, FiMessageCircle } from 'react-icons/fi';
import { FiZap } from 'react-icons/fi';
import { BiMessageRoundedDots } from 'react-icons/bi';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';

const availableIntegrations = [
  {
    colorClass: 'integration__card--gohighlevel',
    icon: GOHIGHLEVEL_ICON,
    badge: 'Popular',
    title: 'GoHighLevel',
    subtitle: 'All-in-one marketing platform for agencies to manage clients, campaigns, and leads.',
    tags: ['Lead management', 'SMS & email marketing', 'Appointment scheduling'],
    key: 'ghl_connected',
    type: 'ghl',
  },
  {
    colorClass: 'integration__card--hubspot',
    icon: HUBSPOT_ICON,
    badge: 'Popular',
    title: 'HubSpot',
    subtitle: 'CRM platform with marketing, sales, customer service, and operations tools.',
    tags: ['CRM', 'Marketing automation', 'Customer service'],
    key: 'hubspot_connected',
    type: 'hubspot',
  },
  {
    colorClass: 'integration__card--calendly',
    icon: CALENDLY_ICON,
    badge: 'Popular',
    title: 'Calendly',
    subtitle: 'Scheduling automation platform for eliminating email back-and-forth.',
    tags: ['Appointment scheduling', 'Calendar integration', 'Team scheduling'],
    key: 'calendly_connected',
    type: 'calendly',
  },
];
const commingSoonIntegrations = [
  // {
  //   colorClass: 'integration__card--zapier',
  //   icon: <FiZap />,
  //   badge: 'Coming Soon',
  //   title: 'Zapier',
  //   subtitle: 'Connect your apps and automate workflows.',
  //   tags: [],
  //   key: '',
  //   type: '',
  // },
  // {
  //   colorClass: 'integration__card--messenger',
  //   icon: <BiMessageRoundedDots />,
  //   badge: 'Coming Soon',
  //   title: 'Messenger',
  //   subtitle: 'Connect with Facebook Messenger for seamless customer communications.',
  //   tags: [],
  //   key: '',
  //   type: '',
  // },
  {
    colorClass: 'integration__card--whatsApp',
    icon: <FaWhatsapp />,
    badge: 'Coming Soon',
    title: 'WhatsApp',
    subtitle: 'Integrate with WhatsApp to reach customers on their preferred messaging platform.',
    tags: [],
    key: '',
    type: '',
  },
  // {
  //   colorClass: 'integration__card--instagram',
  //   icon: <FaInstagram />,
  //   badge: 'Coming Soon',
  //   title: 'Instagram',
  //   subtitle: 'Connect with Instagram to engage with customers through visual content.',
  //   tags: [],
  //   key: '',
  //   type: '',
  // },
];

const IntegrationCard = ({ colorClass, icon, badge, title, subtitle, tags, isConnected, onConnect, gridClass = 'col-md-4 col-12', disabled = false }) => {
  return (
    <div className={gridClass}>
      <div className={`integration__card ${colorClass} position-relative h-100`} style={{ borderLeft: isConnected ? '5px solid #22c55e' : 'none' }}>
        <div className='integration__card-body'>
          <div className='d-flex align-items-center justify-content-between mb-3'>
            <div className={typeof icon === 'string' ? 'integration__icon-box' : 'integration__icon-box-svg'} style={{ color: isConnected ? '#22c55e' : '#b45309' }}>
              {typeof icon === 'string' ? <img src={icon} alt={title + ' icon'} /> : icon}
            </div>
            <span
              className='integration__card-badge rounded-pill outfit-medium'
              style={{ border: isConnected ? '1px solid #22c55e' : 'none', color: isConnected ? '#22c55e' : '#b45309', background: isConnected ? '#dcfce7cc' : '' }}
            >
              {!isConnected ? badge : 'Connected'}
            </span>
          </div>
          <h5 className='integration__card-body-title outfit-bold'>{title}</h5>
          <p className='integration__card-body-subtitle outfit-regular'>{subtitle}</p>
          {tags.length > 0 && (
            <div className='d-flex flex-wrap gap-2 mb-3'>
              {tags?.map((tag, tagIndex) => (
                <span className='integration__card-body-badge rounded-pill' key={tagIndex}>
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
        <div className='integration__card-button'>
          <button
            className={`btn outfit-medium w-100 ${disabled ? 'text-dark' : isConnected ? 'text-danger' : ''} `}
            style={{ background: disabled ? '#F1F5F9' : isConnected ? '#ffffff' : undefined, opacity: disabled ? 0.5 : 1 }}
            onClick={!disabled ? onConnect : undefined}
            disabled={disabled}
          >
            {disabled ? 'Coming Soon' : isConnected ? 'Disconnect' : 'Connect'}
          </button>
        </div>
      </div>
    </div>
  );
};

const Integrations = () => {
  const [editLeadPopup, setEditLeadPopup] = useState(false);
  const [modalType, setModalType] = useState('');
  const [loader, setLoader] = useState(false);
  const [apiTokenData, setApiTokenData] = useState('');
  const [values, setValues] = useState({
    ghl_api_key: '',
    ghl_location_id: '',
    hubspot_api_key: '',
    calendly_api_key: '',
    calendly_event_id: '',
  });

  const [calendlyEvents, setCalendlyEvents] = useState([]);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      const parsedToken = JSON.parse(token);
      setApiTokenData(parsedToken);
      fetchCRMConfigurationDetails(parsedToken);
    } else {
      navigate('/login');
    }
  }, []);

  useEffect(() => {
    if (values.calendly_api_key) {
      fetchCalendlyConfigurationDetails(values.calendly_api_key);
    } else {
      setCalendlyEvents([]);
    }
  }, [values.calendly_api_key]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'calendly_api_key') {
      setValues({ ...values, [name]: value, calendly_event_id: '' });
    } else {
      setValues({ ...values, [name]: value });
    }
    setErrors({ ...errors, [name]: '' });
  };

  const handleSaveClick = async () => {
    try {
      const payload = {
        ghl_api_key: values.ghl_api_key,
        ghl_location_id: values.ghl_location_id,
        hubspot_api_key: values.hubspot_api_key,
        calendly_api_key: values.calendly_api_key,
        calendly_event_id: values.calendly_event_id,
      };

      let response;
      if (values?.id) {
        response = await patchWithToken(`crm_configurations/${values.id}`, apiTokenData, payload);
      } else {
        response = await postWithToken('crm_configurations', apiTokenData, payload);
      }

      if (response.status === 200 || response.status === 201) {
        fetchCRMConfigurationDetails(apiTokenData);
        toast.success(response.message);
        setEditLeadPopup(false);
      } else {
        toast.error(response.message || 'Unexpected error occurred');
      }
    } catch (error) {
      console.error('Error saving configuration:', error);
      toast.error('Something went wrong while saving.');
    }
  };

  const fetchCRMConfigurationDetails = (token) => {
    setLoader(true);
    getWithToken('crm_configurations', token)
      .then((response) => {
        if (response.status === 200 && response.data?.length > 0) {
          setValues(response.data[0]);
        }
      })
      .catch((error) => console.error('error: ', error))
      .finally(() => setLoader(false));
  };

  const fetchCalendlyConfigurationDetails = (apiKey) => {
    postWithToken('get_calendly_events', apiTokenData, { calendly_token: apiKey })
      .then((response) => {
        if (response.status === 200 && response.data?.length > 0) {
          setCalendlyEvents(response.data);
        } else {
          setCalendlyEvents([]);
        }
      })
      .catch((error) => console.error('error: ', error));
  };

  if (loader)
    return (
      <div className='loader-center'>
        <Loader />
      </div>
    );
  return (
    <div className='m-0 mt-2 ps-md-5 ps-sm-4 ps-4 pe-md-5 pe-sm-4 pe-4 mb-3'>
      <div className='container integration-section'>
        {/* <div className='integration__hero text-white text-center mb-4'>
        <div className='integration__badge-wrapper mb-3'>
          <span className='badge--glass outfit-medium'>
            <img src={INTEGRATIONHUB_ICON} alt='integrationhub-icon' className='me-1' /> Integration Hub
          </span>
        </div>

        <div className='integration__heading'>
          <h1 className='outfit-bold'>
            Connect Your <span className='outfit-normal'>Favorite Tools</span>
          </h1>
          <p className='lead'>Seamlessly integrate with popular platforms to automate tasks, boost productivity, and transform your workflow.</p>
        </div>

        <div className='integration__search d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mb-5'>
          <input type='text' className='form-control w-100 w-md-50 integration__search-box' placeholder='Search integrations...' />
          <button className='outfit-medium'>
            Browse Catalog <IoMdArrowForward className='ms-2' />
          </button>
        </div>

        <div className='integration__stats d-flex flex-wrap align-items-center justify-content-center gap-4'>
          {[
            { icon: INTEGRATIONHUB_ICON, title: 'Available Integrations', desc: values?.available_integrations },
            { icon: CHECKCIRCLE_ICON, title: 'Connected', desc: values?.connected_crms_count },
            {
              icon: '',
              title: 'Integration Score',
              desc: values?.connected_percentage === 0 ? 'Getting Started' : values?.connected_percentage < '50%' ? 'Making Progress' : 'Well Connected',
            },
          ].map((item, i) => (
            <div className='integration__info-box d-flex align-items-start gap-3 h-100' key={i}>
              <div className='integration__info-box__icon'>
                {item.icon ? <img src={item.icon} alt='lead-icon' /> : <span className='outfit-bold'>{values?.connected_percentage}</span>}
              </div>
              <div className='text-start'>
                <h6 className='outfit-medium mb-0'>{item.title}</h6>
                <p className='outfit-bold mb-0'>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}

        {/* Cards Section */}
        <div className='comniq-container integration__card-container mb-4'>
          <div className='d-flex flex-column mb-4'>
            <div className='integration__card-header d-flex align-items-center gap-2'>
              <div className='integration__card-header-icon d-flex align-items-center justify-content-center'>
                <img src={CHECKCIRCLE_ICON} alt='integration-icon' width={15} height={15} />
              </div>
              <h5 className='integration__card-header-title outfit-semibold mb-0'>Available Integrations</h5>
            </div>
            <p className='integration__card-header-subtitle outfit-regular mb-0'>Connect your favorite tools to enhance your workflow</p>
          </div>
          <div className='row g-4'>
            {availableIntegrations.map((item, index) => (
              <IntegrationCard
                key={index}
                gridClass='col-md-4 col-12'
                colorClass={item.colorClass}
                icon={item.icon}
                badge={item.badge}
                title={item.title}
                subtitle={item.subtitle}
                tags={item.tags}
                isConnected={!!values[item.key]}
                onConnect={() => {
                  setEditLeadPopup(true);
                  setModalType(item.type);
                }}
                disabled={false}
              />
            ))}
          </div>
        </div>
        <div className='comniq-container integration__card-container mb-4'>
          <div className='d-flex flex-column mb-4'>
            <div className='integration__card-header d-flex align-items-center gap-2'>
              <div className='integration__card-header-icon d-flex align-items-center justify-content-center' style={{ background: 'linear-gradient(to right, #A855F7, #DB2777)' }}>
                {/* <img src={MESSAGE_ICON} alt='integration-icon' width={12} height={12} /> */}
                <FiMessageCircle width={12} height={12} className='text-white' />
              </div>
              <h5 className='integration__card-header-title outfit-semibold mb-0'>Coming Soon</h5>
            </div>
            <p className='integration__card-header-subtitle outfit-regular mb-0'>Exciting new integrations on the way</p>
          </div>
          <div className='row g-4'>
            {commingSoonIntegrations.map((item, index) => (
              <IntegrationCard
                key={index}
                gridClass='col-md-3 col-12'
                colorClass={item.colorClass}
                icon={item.icon}
                badge={item.badge}
                title={item.title}
                subtitle={item.subtitle}
                tags={item.tags}
                isConnected={!!values[item.key]}
                onConnect={() => {
                  setEditLeadPopup(true);
                  setModalType(item.type);
                }}
                disabled={true}
              />
            ))}
          </div>
        </div>

        {/* <div className='integration__footer text-white text-center mb-4'>
        <div className='integration__footer-wrapper mb-3'>
          <img src={INTEGRATIONHUB_ICON} alt='integrationhub-icon' width={40} height={40} />
        </div>

        <div className='integration__footer-text'>
          <h1 className='outfit-bold'>Need Another Integration?</h1>
          <p className='lead outfit-regular'>We're constantly expanding our integration catalog. Let us know which tools you'd like to connect with.</p>
        </div>

        <div className='integration__footer-button d-flex flex-column flex-md-row justify-content-center align-items-center'>
          <button className='outfit-medium'>Request an Integration</button>
        </div>
      </div> */}

        <IntegrationModal
          isOpen={editLeadPopup}
          onClose={() => setEditLeadPopup(false)}
          modalType={modalType}
          values={values}
          onChange={handleInputChange}
          onSave={handleSaveClick}
          calendlyEvents={calendlyEvents}
        />
      </div>
    </div>
  );
};

export default Integrations;
